// @flow
export const AUTO_WIDTH: 'auto' = 'auto';
const CELL_INDEX_OFFSET = 1;

export const getRightOffset = (offsetWidth: Array<number>, cellEndIndex: number): 'auto' | number => {
    return offsetWidth[cellEndIndex + CELL_INDEX_OFFSET] ? AUTO_WIDTH : 0;
};
